import React from 'react'
import './index.css'
import './utils/axiosErrors'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { createRoot } from 'react-dom/client'
createRoot(document.getElementById('root')).render(<App />)


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
